export const WILDCARD_ADDED_FLAG_ID = 'WILDCARD_ADDED_FLAG_ID';
